import axios from 'axios';

import { NutriScoreCategory } from 'enums/nutriScoreCategory';
import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string, putObject: Request): Promise<Optional<void>> {
	const url = `${SERVICEBASEURL.BACKEND}/IngredientCategory/${id}`;
	return axios.put(url, putObject).toOptionalVoid();
}

export interface Request {
	parentId: string | null;
	nutriScoreCategory: NutriScoreCategory | null;
	nameTranslations: {
		[key: string]: string;
	};
}
